import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsMaintenanceStrategy, PmsMaintenanceStrategy } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsMaintenanceStrategy>
    useData={usePmsMaintenanceStrategy}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
